<div class="seperator"></div>
<div class="title" mat-dialog-title>Add {{captionKey}} & {{captionSecret}}</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your {{platform}} support to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{captionKey}}</mat-label>
                <input matInput placeholder="Enter {{platform}} {{captionKey}}" formControlName="clientId" data-cy="common-client-id-input">
                <mat-error
                    *ngIf="connectionForm.get('clientId').errors && (connectionForm.get('clientId').touched || connectionForm.get('clientId').dirty)">
                    Invalid {{captionKey}}</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>{{captionSecret}}</mat-label>
                <input type="password" matInput placeholder="Enter {{platform}} {{captionSecret}}" formControlName="clientSecret" data-cy="common-client-secret-input">
                <mat-error
                    *ngIf="connectionForm.get('clientSecret').errors && (connectionForm.get('clientSecret').touched || connectionForm.get('clientSecret').dirty)">
                    Invalid {{captionSecret}}</mat-error>
                </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="outbrain-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>